@if (visible()) {
  <div class="offline-banner" role="status" aria-live="polite" data-cy="offline-banner">
    <i class="uil uil-wifi offline-banner__icon" aria-hidden="true"></i>
    <span class="offline-banner__title">Você está em modo Offline</span>
  </div>
}
